/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UserBadgeResponse } from './UserBadgeResponse';
import {
    UserBadgeResponseFromJSON,
    UserBadgeResponseFromJSONTyped,
    UserBadgeResponseToJSON,
    UserBadgeResponseToJSONTyped,
} from './UserBadgeResponse';

/**
 * 
 * @export
 * @interface MyBadgesResponse
 */
export interface MyBadgesResponse {
    /**
     * 
     * @type {Array<UserBadgeResponse>}
     * @memberof MyBadgesResponse
     */
    badges: Array<UserBadgeResponse>;
}

/**
 * Check if a given object implements the MyBadgesResponse interface.
 */
export function instanceOfMyBadgesResponse(value: object): value is MyBadgesResponse {
    if (!('badges' in value) || value['badges'] === undefined) return false;
    return true;
}

export function MyBadgesResponseFromJSON(json: any): MyBadgesResponse {
    return MyBadgesResponseFromJSONTyped(json, false);
}

export function MyBadgesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): MyBadgesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'badges': ((json['badges'] as Array<any>).map(UserBadgeResponseFromJSON)),
    };
}

export function MyBadgesResponseToJSON(json: any): MyBadgesResponse {
    return MyBadgesResponseToJSONTyped(json, false);
}

export function MyBadgesResponseToJSONTyped(value?: MyBadgesResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'badges': ((value['badges'] as Array<any>).map(UserBadgeResponseToJSON)),
    };
}

